<template>

  <van-list
  class="cursor_card m-t2 m-l-4"
  >
  
  <van-cell class="cell_card_diametre style_card all_border_radius"  clickable @click="chooseDiametreCoB(1 , '900µ')" >
    
    <van-row class="row_card">
    <van-col class="d-content " span="4">
  
      <span v-if="(StorePkDiametreCoB == 1)" style="color:#1989fa">900µ</span>
      <span v-else>900µ</span>
  
    </van-col>
  
    <van-col class="d-content " span="3">
      <van-icon v-if="(StorePkDiametreCoB == 1)" class="icon_check_choice" name="success" color="#1989fa" style="vertical-align: top" size="20" />
  
    </van-col>
  
  </van-row>
  
  </van-cell>
  

    
  <van-cell v-if="this.$store.state.storeCable.cable.structure.codeRefStructureFamille != 'PUR'" class="cell_card_diametre style_card all_border_radius"  clickable @click="chooseDiametreCoB(2 , '2mm')" >
    
    <van-row class="row_card">
    <van-col class="d-content " span="4">
  
      <span v-if="(StorePkDiametreCoB == 2)" style="color:#1989fa">2mm</span>
      <span v-else>2mm</span>
  
    </van-col>
  
    <van-col class="d-content " span="3">
      <van-icon v-if="(StorePkDiametreCoB == 2)" class="icon_check_choice"  name="success" color="#1989fa" style="vertical-align: top" size="20" />
  
    </van-col>
  
  </van-row>
  
  </van-cell>

  <van-cell v-if="this.$store.state.storeCable.cable.structure.codeRefStructureFamille == 'PUR'" class="cell_card_diametre style_card all_border_radius"  clickable @click="chooseDiametreCoB(3 , '3mm')" >
    
    <van-row class="row_card">
    <van-col class="d-content " span="4">
  
      <span v-if="(StorePkDiametreCoB == 3)" style="color:#1989fa">3mm</span>
      <span v-else>3mm</span>
  
    </van-col>
  
    <van-col class="d-content " span="3">
      <van-icon v-if="(StorePkDiametreCoB == 3)" class="icon_check_choice"  name="success" color="#1989fa" style="vertical-align: top" size="20" />
  
    </van-col>
  
  </van-row>
  
  </van-cell>


  </van-list>
  
  
      </template>
      
      
      <script>
      //import Spinner from '../../../loader/Spinner.vue'
      export default {
        components: {
       //   Spinner,
        },
        data() {
          return {
            LoadCob: false,
          }
        },
      computed: {
          /** Connecteur A*/
          StorePkDiametreCoB() {
            return this.globalFunction.existKeyInArray("diametre", this.$store.state.storeCoB.coB) 
                  ? this.$store.state.storeCoB.coB.diametre.pkDiametre
                  : null 
              },
            },
      methods: {
        chooseDiametreCoB(pkDiametre, typeDiametre){

          this.obj = {  
          'coB' : {
            'diametre' : {
              pkDiametre:pkDiametre,
              typeDiametre: typeDiametre
        }
        }};
       
        this.$store.commit('SET_CHOICE_COB', this.obj )

        this.obj = {  
          'coA' : {
            'diametre' : {
              pkDiametre:pkDiametre,
              typeDiametre: typeDiametre
        }
        }};
       
        this.$store.commit('SET_CHOICE_COA', this.obj )

        }
        
      },
      
      
      }
      </script>